import type { SxStyle, SxStyleFunc } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const icon: SxStyleFunc<boolean> = (available) => ({
  '&:hover': {
    color: available
      ? (p) => p.palette.primary[300]
      : (p) => p.palette.grey[400],
  },
});

export const linkButton: SxStyle = { minWidth: 4.5 };

export const socialLinkButton: SxStyleFunc<boolean> = (available) => ({
  minWidth: 4.5,
  opacity: available ? 1 : 0.3,
  cursor: available ? 'pointer' : 'default',
});
